class BtnDiscount extends HTMLElement {
  constructor() {
    super();
    this.shadow = this.attachShadow({ mode: "open" }); 
  }
  connectedCallback() {
    this.render();
    this.shadow.querySelector('.btn-discount-button').addEventListener('click', this.onOpen.bind(this));
  }
  templateBlock(){
    return `
    <style>
      :host {
        display: block;
        margin-top: 16px;
      }
      .btn-discount-container {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .btn-discount-button {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 15.5px 30px;
        outline: none;
        border-radius: 50px;
        background-color: #fff;
        border: solid 1px #2D51A4;
        color: #2D51A4;
        font-size: 14px;
        width: 100%;
        cursor: pointer;
        font-family: var(--typeBasePrimary),var(--typeBaseFallback);
      }
      .btn-discount-button:hover {
        background:#2D51A4;
        color: #fff;
      }
      @media screen and (max-width: 768px){
        .btn-discount-button {
          height: 41px;
        }
      }
    </style>
    <div class="btn-discount-container">
      <button type="button" class="btn-discount-button">
        <span class="btn-discount__text">${this.getAttribute('data-label') ?? "New Discount"}</span>
      </button>
    </div>
    `;
  }
  templateSimple(){
    return `
    <style>
      :host {
        display: block;
        margin-bottom: 4px;
      }
      .btn-discount-container {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .btn-discount-button {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding: 5px 0px;
        outline: none;
        border-radius: 50px;
        border: none;
        color: #2D51A4;
        font-size: 16px;
        width: 100%;
        cursor: pointer;
        text-decoration: underline;
        apparance: none;
        -webkit-appearance: none;
        column-gap: 8.95px;
        background: none;
        font-family: var(--typeBasePrimary),var(--typeBaseFallback);
      }
      @media screen and (max-width: 768px){
        :host {
          margin-bottom: 16px;
        }

        .btn-discount-button {
          font-size: 14px;
        }
      }
    </style>
    <div class="btn-discount-container">
      <button type="button" class="btn-discount-button">
        <span class="btn-discount__text">${this.getAttribute('data-label') ?? "New Discount"}</span>
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.08398 5.41671H10.9173V7.25004H9.08398V5.41671ZM9.08398 9.08337H10.9173V14.5834H9.08398V9.08337ZM10.0007 0.833374C4.94065 0.833374 0.833984 4.94004 0.833984 10C0.833984 15.06 4.94065 19.1667 10.0007 19.1667C15.0607 19.1667 19.1673 15.06 19.1673 10C19.1673 4.94004 15.0607 0.833374 10.0007 0.833374ZM10.0007 17.3334C5.95815 17.3334 2.66732 14.0425 2.66732 10C2.66732 5.95754 5.95815 2.66671 10.0007 2.66671C14.0432 2.66671 17.334 5.95754 17.334 10C17.334 14.0425 14.0432 17.3334 10.0007 17.3334Z" fill="#2D51A4"/>
        </svg>
      </button>
    </div>
    `;
  }
  render(){
    this.shadow.innerHTML = this.getAttribute('data-mode') === 'block' ? this.templateBlock() : this.templateSimple();
  }
  onOpen(event){
    window.postscript?.popups.find({triggerType: 'Custom'}).then((id) => {
      if(id) {
        window.postscript.popups.open(id, {
          activePopupBehavior: 'ALWAYS_DISMISS',
          respectPopupStatus: false
        });
        gtag('event', 'open_new_customer_discount', {});
      }
    });
  }
}

window.customElements.define("btn-discount", BtnDiscount);